import { createAutoAnimatePlugin } from '@formkit/addons'
import type { DefaultConfigOptions } from '@formkit/vue'

const config: DefaultConfigOptions = {
  plugins: [createAutoAnimatePlugin()],
}

export default config
